<script>
import './style.scss';
import template from './order_template.html';
import axios from 'axios';
import {EventBus} from "../../event-bus";
import DensityOption from './components/Density-Option/DensityOption.vue';
import HideNShow from './components/Hide-N-Show/HideNShow.vue';
import AsCell from './cells/AsCell';
import {Event} from 'vue-tables-2';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {findKey, forEach, includes, isArray, isEmpty, isObject, values} from 'lodash';
import {nanoid} from 'nanoid';
import debounce from 'lodash/debounce'
import Vue from 'vue'
import {
    MY_ROLE_FILTER,
    ALL_FILTER,
    CUSTOM_FILTER,
    PROJECT_MANAGER_FILTER,
    SUPERVISOR_FILTER,
    TEAM_MEMBER_FILTER
} from './constants'
//@TODO - we use this throughout our app so we should load them in acclaro.js
import {CloseIcon, DownloadIcon, FilterOutlineIcon, LoadingIcon, ResizeIcon,} from '../icons.js';

let abortController;

let $token = $("#token");

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if ($token.length) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = $token.attr('content');
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const EventTypes = {
    filtering: 'filter'
};

const RequestTypes = {
    preprocessed: 'preprocessed',
    default: 'search',
};

const PreferenceNamespace = 'acclarosearchview';
const HIDE_SHOW_NAMESPACE = 'hidenshow_v1';

const PREFERENCES = {
    rowHeight: 'rowheight'
};

export default {


    template,
    data() {

        let isFirstLoad = true;
        let lastFilters = null;

        const getDefaultFilters = () => {
            let filters = [];

            if (this.filterByKey) filters.push({title: 'filter-by', key: this.filterByKey});

            if (this.filterParam) filters.push({title: 'filter', key: this.filterParam});

            if (this.tagsParam) filters.push({title: 'tags', key: this.tagsParam});

            if (this.isAssignedView) filters.push({
                "title": MY_ROLE_FILTER,
                "key": [PROJECT_MANAGER_FILTER]
            })

            return filters;
        };

        /**
         * Build an array of all selected filters
         * include the latest selected filter option
         *
         * @return array
         * @param filter
         * @param firstLoad
         */
        const buildActiveFilterArr = ({key, title}, firstLoad = false) => {

            const dateKeys = Object.values(this.filters)
                .filter(item => item.isDate)
                .map(item => item.name);

            console.log(dateKeys, key, title)

            const isAssigned = this.isAssignedView;
            function getDefaultActiveFilters() {
                return [{
                    "title": MY_ROLE_FILTER,
                    "key": [PROJECT_MANAGER_FILTER]
                }];
            }

            function getExistingFilterIndex(activeFilters) {
                return activeFilters.findIndex(f => f.title === title);
            }

            function updateExistingFilter(activeFilters, index) {
                const existingFilter = activeFilters[index];
                addOrRemoveKeyFromFilter(existingFilter);
                if (existingFilter.key.length === 0 || existingFilter.key.includes(ALL_FILTER)) {
                    existingFilter.key = [ALL_FILTER];
                }
            }

            function addOrRemoveKeyFromFilter(filter) {
                // Directly set the filter for specific keys 'y' or 'n', or for a specific view and title
                const isDateField = dateKeys.includes(title)
                if (isDateField || key === 'y' || key === 'n' || (isAssigned && title === MY_ROLE_FILTER)) {
                    filter.key = [key];
                    return;
                }

                // Proceed only if filter.key is an array
                if (!Array.isArray(filter.key)) {
                    filter.key = filter.key !== key ? [filter.key, key] : [];
                    return;
                }

                // If the key is not in the filter, add it
                if (!filter.key.includes(key)) {
                    // Replace the filter if it contains a custom filter, otherwise add the new key
                    filter.key = filter.key.length === 1 && filter.key[0].includes(CUSTOM_FILTER) ? [key] : [...filter.key, key];
                    return;
                }

                // If the key is already in the filter, remove it
                filter.key = filter.key.filter(k => k !== key);

                // Normalize filter if empty
                if (filter.key.length === 0) {
                    filter.key = [ALL_FILTER];
                }
            }

            function handleNewFilter(activeFilters) {
                activeFilters.push({ key, title });
            }

            // Main logic of buildActiveFilterArr

            let activeFilters = firstLoad && isAssigned
                ? getDefaultActiveFilters()
                : this.getActiveFilterParams();

            const searchFilterStr = JSON.stringify(this.searchFilter);

            let filtersChanged = lastFilters !== searchFilterStr;
            lastFilters = searchFilterStr;

            const existingFilterIndex = getExistingFilterIndex(activeFilters);

            if (key !== undefined && filtersChanged) {
                if (existingFilterIndex !== -1) {
                    updateExistingFilter(activeFilters, existingFilterIndex);
                } else {
                    handleNewFilter(activeFilters);
                }
            }

            return activeFilters;
        };

        const searchRequestFunction = (data) => {
            if (this.requestType == RequestTypes.preprocessed) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: this.searchResults,
                        count: this.resultsCount
                    })
                })
            }

            let {page, limit, byColumn, ascending, orderBy} = data;
            let query = this.searchString;
            let filter = this.searchFilter;
            let sortdir = ascending ? 'a' : 'd';
            let accountId = this.accountId;
            let myRole = this.isAssignedView ? this.selectedRole.code : '';

            let params = {page, limit, sortdir, accountId, 'my-role': myRole};

            if (filter.title === 'filter-by') {
                params['filter-by'] = filter.key;
            }

            if (orderBy && this.columnsObj) {
                //orderBy is the displayName of a column, we need to search the columnsObj
                //and find the column containing this display name, then return the key wich
                //we use as a param in our search request
                let sort = findKey(this.columnsObj, chr => chr.displayName == orderBy);
                params = Object.assign({}, params, {sort, tb: 'order'});
            }
            if (isFirstLoad) {
                filter = getDefaultFilters();
                EventBus.$emit('loader:show');
            }
            //add all unique active filters
            if (this.hasFilterRoute && this.hasAggregateRoute) {
                filter = buildActiveFilterArr(filter, isFirstLoad);
            }
            return this.search(query, filter, params)
        };

        const requestFunction = (data) => {
            return searchRequestFunction(data).then(result => {
                if (isFirstLoad) {
                    isFirstLoad = false;
                    this.isLoaded = true;
                    this.tableOptions.totalPages = this.resultsCount;
                    //isFirstLoad = false;

                    //if this is the first load let the filters know
                    //that we need to update/load them
                    this.$emit('datatables.filter');
                }

                //set request type to default after every request
                this.updateRequestType(RequestTypes.default);

                EventBus.$emit('loader:hide');
                this.isLoading = false;

                //if the request is cancelled and no data is returned
                //return the current data so we don't have an empty grid
                return {data: result || {data: this.searchResults, count: this.resultsCount}};
            })
        };

        const setOptions = (options) => {
            const defaultOpts = {
                //templates: Object.assign({}, defaultCellValues()),
                noResultsSearchLinks: this.noResultsSearchLinks,
                filterable: false,
                editableColumns: ['Description', 'PO Amount'],
                perPage: this.limit,
                totalPages: null,
                requestFunction,
                templates: this.columnTemplates || {},
                /*orderBy: {
                  ascending: false,
                  column: 'ID'
                },*/
                texts: {
                    noResults: this.noResults || 'Search or Filter returned no results. <span class="clickable">Reset Filter(s)</span>'
                },
                columnsClasses: {
                    Comments: 'th-comments'
                },
                hiddenColumns: []
            };

            return Object.assign({}, defaultOpts, options);
        };

        return {
            selectedRole: {label: 'Project Manager', code: PROJECT_MANAGER_FILTER},
            roles: [
                {label: 'Supervisor', code: SUPERVISOR_FILTER},
                {label: 'Project Manager', code: PROJECT_MANAGER_FILTER},
                {label: 'Team Member', code: TEAM_MEMBER_FILTER}
            ],
            rowHeight: 'large',
            downloadUrl: this.downloadRoute || '',
            aggregates: {},
            searchFilter: {},
            isLoading: false,
            isFullscreen: false,
            requestsInProgress: [],
            columnsObj: {},
            savedColumns: null,
            savedColumnsIsLoading: false,
            currentPage: 1,
            filterByKey: this.filterByParam,
            debounceSearch: debounce(this.onSearch, 1100),
            resultsCount: 0,
            selectedResultType: 'All',
            isLoaded: false,
            //these are the columns that have no special slots set
            //we will use a standard AsCell component to display them
            defaultSlotColumns: [],
            userPrefs: {},
            toggles: {},
            tableOptions: setOptions(this.options),
            searchResults: [],
            filters: {},
        };
    },


    props: {
        //@TODO - create an options object
        //@TODO - creaete func to pick up any valid filter
        searchParam: String,
        showSearchFilter: {
            type: Boolean,
            default: true
        },
        showDensitySetting: {
            type: Boolean,
            default: true
        },
        isProgram: {
            type: Number,
            default: null
        },
        noResultsSearchLinks: {
            type: Array,
            default: function () {
                return [];
            }
        },
        filterByParam: {
            default: 'all',
        },

        filterParam: {
            type: String,
            default: ''
        },

        tagsParam: {
            type: String,
            default: ''
        },

        options: {
            type: Object
        },

        searchRoute: String,

        aggregateRoute: String,

        filterRoute: String,

        downloadRoute: String,

        searchType: String,

        gridTitle: String,

        searchPlaceholder: String,

        noResults: String,

        gridClasses: {
            type: Array,
            default: function () {
                return []
            }
        },

        isAdmin: {
            type: Boolean,
            default: false
        },
        isAssignedView: {
            type: Boolean,
            default: false
        },

        gridOnly: {
            type: Boolean,
            default: false
        },

        showButtons: {
            type: Boolean,
            default: true,
        },

        columnStructure: {
            type: Object,
        },

        columnTemplates: {
            type: Object,
            default: function () {
                return {}
            }
        },
        limit: {
            type: Number,
            default: 50
        },

        datatableName: {
            type: String,
        },
        programId: {
            type: Number,
        },
    },
    created() {
        Event.$on('vue-tables.pagination', (currentPage) => {
            this.currentPage = currentPage;
            this.isLoading = true;
        });

        Event.$on('vue-tables.sorted', (obj) => {
            this.isLoading = true;
        });

        Event.$on('vue-tables.refresh-table', (obj) => {
            this.$refs.table.refresh();
        });

        //datatables filter updated or needs updating
        this.$on('datatables.filter', (eventType) => {
            if (this.hasFilterRoute && this.hasAggregateRoute) {
                this.updateFilterAndAggregateData();
            } else if (this.hasFilterRoute && !this.hasAggregateRoute) {
                this.updateFilterRoute();
            }
        });

        this.$on('datatables.search', (eventType) => {
            if (this.hasFilterRoute && this.hasAggregateRoute) {
                this.updateFilterAndAggregateData();
            }
        });

        //update store if initial search param is set
        if (this.searchParam) {
            this.updateQueryValue(this.searchParam);
        }

        //set column structure based on props
        if (this.columnStructure) {
            this.setColumns(this.columnStructure);
        }

        //fetch user preferences for row height
        this.getUserPreference({
            type: PreferenceNamespace,
            key: PREFERENCES.rowHeight,
        }).then(result => {
            let {value} = result.data;

            this.userPrefs = Object.assign({}, this.userPrefs, {row_height: value});
        })

        //fetch user preferences for custom columns
        if (this.datatableName) {
            this.savedColumnsIsLoading = true;

            this.getUserPreference({
                type: HIDE_SHOW_NAMESPACE,
                key: this.datatableName
            }).then(result => {
                let {key, type, value} = result.data;
                let savedColumns = [];

                try {
                    if (key !== 'undefined' && key !== undefined && value) {
                        savedColumns = JSON.parse(value).columns;
                    }
                } catch ($e) {
                    console.error('failed to parse saved columns:', $e)
                }

                this.savedColumns = savedColumns;
                this.savedColumnsIsLoading = false;
            });
        } else {
            console.warn('no datatable name give, user preferences may not be saved or loaded');
        }
    },

    watch: {
        accountId: function (newAccountId, oldAccountId) {

            // when the computed proxy prop this.$store.TRMOnBehalfStore.state.onBehalfAccountId
            // changes, refresh the table
            this.refreshTable();
        },

        searchString: function (searchString) {
            //add new search string to store
            this.updateQueryValue(searchString);
        },

        hiddenColumns: function (columns) {
            this.updateHiddenColumns(columns);
        },

        aggregates: function (aggregates) {
            if (!aggregates) return;
        }
    },

    methods: {
        ...mapMutations('ReviewerImportFormStore', [
            'toggleShowForm',
        ]),
        ...mapActions('AcclaroSearchStore', [
            'updateQueryValue',
            'updateRequestType',
            'updateCurrentParams',
            'updateColumns',
        ]),
        onPMSelectChange(value) {
            this.selectedRole = value
            this.onSearch({title: MY_ROLE_FILTER, key: this.selectedRole.code}, EventTypes.filtering);
        },

        updateHiddenColumns(columns) {
            let table = this.$refs.table.$refs.table;
            let allColumns = table.Columns;
            let visibleColumns = table.allColumns;
            let hiddenColumns = allColumns.filter(col => !visibleColumns.includes(col))

            columns.forEach(col => {
                if (!hiddenColumns.includes(col)) {
                    this.toggleHiddenColumn(col);
                }
            })

            //remove any hidden column that isn't in our list of
            //our hidden columns
            hiddenColumns.forEach(col => {
                if (!columns.includes(col)) {
                    //make it visible
                    this.toggleHiddenColumn(col);
                }
            })
        },

        toggleHiddenColumn(column) {
            this.$refs.table.$refs.table.toggleColumn(column)
        },

        onFilterByUpdate(filter) {
            let {name, type, id} = filter;

            this.updateFilters({list_title: 'filter-by', key: id});

            this.filterByKey = filter.id;
        },

        updateFilters(selectedFilter) {
            let {list_title: title, key} = selectedFilter;

            this.onSearch({title, key}, EventTypes.filtering);
        },

        removeFilter(filter) {
            let {name: title, defaultKey: key} = filter;
            this.reset();
            this.onSearch({title, key}, EventTypes.filtering);
            if (filter.name == 'filter-by') {
                this.filterByKey = filter.defaultKey;
            }
        },

        updateSearchQuery(query, filter, debounceTime) {
            this.searchString = query;

            //if a custom debounce time has been set
            //overide the default time.  This is usually done if we want the
            //search to perform instantly
            if (debounceTime) {
                debounce(this.onSearch, debounceTime)(filter, 'search');
            } else {
                this.onSearch(filter, 'search');
            }
        },

        onSearch(filter, eventType) {
            if (filter) this.searchFilter = filter;
            this.currentPage = 1;
            this.$refs.table.setPage(1);
            if (eventType) {
                this.$emit(`datatables.${eventType}`, eventType);
            }
        },

        _parseRowData(data, columns) {
            return data.map((row) => {
                let obj = {};


                for (let prop in row) {

                    let columnObj = columns[prop];

                    if (columnObj) {

                        obj[columnObj.displayName] = row[prop];
                    }
                }

                return Object.assign({}, row, obj);
            });
        },


        /**
         * if this is the 'fitler-by' filter check
         * if our search string is currently empty
         *
         *
         * @param Object filter
         */
        emptyFilterBySearch(filter) {
            if (filter.name !== 'filter-by') return false;

            return this.searchString.length == 0;
        },

        /**
         * if this is the 'fitler-by' filter check
         * if our search string is currently empty
         *
         *
         * @param filter
         */
        assignedPmFilter(filter) {
            return filter.name === MY_ROLE_FILTER && this.isAssignedView;
        },

        showActiveFilter(filter) {
            return !this.isDefaultFilter(filter) && !this.emptyFilterBySearch(filter) && !this.assignedPmFilter(filter)
        },

        /**
         * Sets the total possible results count for query
         *
         * @param Object aggregates {total}
         * @return Integer resultsCount
         */
        setResultsCount(aggregates) {
            this.resultsCount = parseInt(
                (aggregates.order_count && aggregates.order_count.toString().replace(/,/g, ''))
                || aggregates.total
                || 0
            );

            return this.resultsCount;
        },

        /**
         * Set aggregate filter objects
         *
         * @param Object value
         * @return Object
         */
        setAggregates(aggregates) {
            return this.aggregates = aggregates;
        },

        /**
         * set datatable columns
         *
         * @param Array columns [{column}]
         * @return Array columns
         */
        setColumns(columns) {
            //create an array of column names
            let columnNames = values(columns).map((c) => c.displayName);

            this.columns.length = 0;
            this.columnsObj = columns;
            columnNames.forEach(column => this.columns.push(column));

            //find the columns that we haven't set special templates for
            //we will use a default template for these
            this.defaultSlotColumns = this.columns.filter(
                col => !includes(Object.keys(this.columnTemplates), col)
            );

            return this.columns;
        },

        /**
         * set filter objects
         *
         * @return Object
         * @param filters
         */
        setFilters(filters) {
            if (values(filters).length) {
                //some filters don't have a default selection when returned from the DB
                //so we set them here
                for (let prop in filters) {
                    let filter = filters[prop];

                    filter.selectedOptions = filter.selectedOptions || filter.defaultKey;
                }

                //set the grid filters
                this.filters = Object.assign({}, this.filters, filters);
            }

            return this.filters;
        },

        /**
         * Set search results (rows)
         *
         * @param Array rows
         * @return Array resultRows
         */
        setSearchResultRows(rows) {
            //empty the current search results
            this.searchResults.splice(0, this.searchResults.length);

            //add the new results to the search results array
            rows.forEach(row => this.searchResults.push(row));

            return rows;
        },


        /**
         * Get param values for all active filters
         *
         * @return array
         */
        getActiveFilterParams() {
            return values(this.filters)
                .filter(filter => !this.isDefaultFilter(filter))
                .map(filter => ({title: filter.name, key: filter.selectedOptions}))
        },

        /**
         * Get/set aggregate data from route
         *
         * @return Object aggregates
         */
        getSetAggregateData() {
            const params = this.datatableParams || {};
            let myRole = this.isAssignedView ? this.selectedRole.code : '';
            params['my-role'] = myRole;
            params['filter-by'] = this.searchFilter.key;

            return axios.get(this.aggregateRoute, {params}).then(result => {
                let {data} = result;

                this.setAggregates(data);

                return this.aggregates;
            })
        },

        /**
         * Get/Set Filter data from route
         *
         * @return Object filters
         */
        getSetFilterData() {
            const params = this.datatableParams || {};

            return axios.get(this.filterRoute, {params}).then(result => {
                let {data} = result;

                return this.setFilters(data);
            })
        },

        /**
         * update the datatables filters and aggregates
         *
         * @return Promise
         */
        updateFilterRoute() {
            //set filters and aggregates
            let filterReq = this.getSetFilterData();

            //get the aggregate and filter data
            return filterReq.then(result => {
                //let our request function know that we don't need new data
                //we only updated filters and aggregates
                // this.updateRequestType(RequestTypes.preprocessed);
                //refresh the table
            });
        },

        /**
         * update the datatatables filters and aggregates
         *
         * @return Promise
         */
        updateFilterAndAggregateData() {
            //set filters and aggregates
            let aggReq = this.getSetAggregateData();
            let filterReq = this.getSetFilterData();

            //get the aggregate and filter data
            return Promise.all([aggReq, filterReq]).then(result => {
                //let our request function know that we don't need new data
                //we only updated filters and aggregates
                // this.updateRequestType(RequestTypes.preprocessed);
                //refresh the table
            });
        },

        /**
         * Main search function
         *
         * @return Promise
         * @param query
         * @param filter
         * @param options
         */
        search(query, filter, options = {}) {
            let params = {query};
            let filterOpts = {};
            let requestId = nanoid();

            EventBus.$emit('loader:show');

            filter.forEach(filter => {
                const {title, key} = filter;

                if (title in filterOpts) {
                    if (Array.isArray(key)) {
                        filterOpts[title].push(...key);
                    } else {
                        if (!filterOpts[title].includes(key)) {
                            filterOpts[title].push(key);
                        }
                    }
                } else {
                    if (Array.isArray(key)) {
                        filterOpts[title] = [...key];
                    } else {
                        filterOpts[title] = [key];
                    }
                }
            });

            if (this.isAdmin) {
                options['is_admin'] = true;
            }

            if (this.programId) {
                // take filters and add a key
                filterOpts['programId'] = this.programId;
            }

            params = Object.assign({}, params, filterOpts, options, {filters: filterOpts});

            this.updateCurrentParams(params);

            //cancel previous search request
            if (this.requestsInProgress.length) {
                cancel('Operation canceled by the user.');
            }

            this.requestsInProgress.push(nanoid);

            // Cancel any previous request
            if (abortController) {
                abortController.abort();
            }
            abortController = new AbortController();

            return axios.get(this.searchRoute, {
                params,
                signal: abortController.signal
            })
                .then((response) => {
                    let {columns, data, aggregates, filters, total, user_prefs, grid} = response.data;
                    let downloadUrl = null;
                    if (grid) {
                        downloadUrl = grid.downloadUrl;
                    }

                    //use preset columns if no column structure was retrieved from request
                    if (!columns && this.columnStructure) columns = this.columnStructure;

                    //parse the row data
                    try {
                        //change key/value data object into an array of row objects for grid component
                        let rows = this._parseRowData(data, columns);
                        this.setSearchResultRows(rows);
                    } catch ($e) {
                        console.error('failed to parse row data:', $e);
                        throw new error('failed to parse row data:' + $e.message);
                    }

                    //if the columns haven't arleady been set then set them
                    if (!this.columns.length) {
                        try {
                            this.setColumns(columns);
                        } catch ($e) {
                            console.error('error setting columns', $e);
                        }
                    }

                    //check if we should expect the filters in a separate request
                    if (!this.hasFilterRoute) {
                        try {
                            this.setFilters(filters);
                        } catch ($e) {
                            console.error('error setting filters:', $e);
                        }
                    }

                    if (downloadUrl) {
                        this.downloadUrl = downloadUrl;
                    }

                    //check if we should expect aggregates in a seperate request
                    if (!this.hasAggregateRoute) {
                        try {
                            this.setAggregates(aggregates);
                        } catch ($e) {
                            console.error('error setting aggregates/resultcounts', $e);
                        }
                    }

                    //set the total possible results count
                    //@TODO - remove the order reference from aggregates
                    //cleanup function below
                    try {
                        this.setResultsCount(aggregates || {total: total || 0})
                    } catch ($e) {
                        console.error('error setting results count:', $e);
                    }

                    //set user preferences
                    if (isObject(user_prefs)) {
                        this.userPrefs = Object.assign({}, this.userPrefs, user_prefs);
                    }

                    //setup legacy popups and links
                    this._setLegacyEvents();
                    return {
                        count: this.resultsCount,
                        data: this.results.rows,
                    }
                })
                .catch((error) => {
                    if (error.name === 'AbortError') {
                        console.log('req cancelled', error.message);
                    }
                })
                .finally(() => {
                    EventBus.$emit('loader:hide')
                    //remove the request id from requests queue
                    this.requestsInProgress
                        .splice(this.requestsInProgress.indexOf(requestId), 1);
                })
        },

        getSelectedOption(list) {
            const hasCustomKey = list.selectedOptions?.some(opt => opt?.includes('custom:'));

            if (hasCustomKey) {
                const customSelection = list.selectedOptions.find(opt => opt?.includes('custom:'));
                return customSelection.substring(7).replace('|', ' – ');
            }

            const selected = list.selectedOptions
                ?.map(opt => list.options[opt])
                .filter(Boolean)
                .join(', ');

            return selected || '';
        },

        toggle(state) {
            if (state) {
                this.isActive = state;
                return;
            }

            this.isActive = !this.isActive;
        },

        reset() {
            this.resultsCount = 0;
            this.searchResults.splice(0, this.searchResults.length);
            this.searchString = "";
        },

        resetTable(type) {
            this.onSearch({title: 'filter', key: 'clear'});
        },

        downloadCSV(event) {
            if (this.resultsCount > 5000) {
                event.preventDefault();

                popupAlert(
                    `To download a spreadsheet with over 5,000 orders please contact ${process.env.MIX_SUPPORT_EMAIL || 'support@acclaro.com'} for support`,
                    'You can download a maximum of 5,000 orders'
                );
            } else {
                window.location = this.downloadHref;
            }
        },

        resultTypeCount(type) {
            if (type == 'All') return this.searchResults.length;

            return this.searchResults.filter(result => result.type == type).length;
        },

        getIcon(type) {
            return `${type}Icon`;
        },

        _setLegacyEvents() {
            setTimeout(() => {
                $('.grid-cell-comment').off();

                initCommentsPopup();
                initFeedbackLink();
            })
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        isDefaultFilter(filter) {
            return filter?.selectedOptions?.includes(filter.defaultKey);
        },

        rowDensity(size) {
            let params = {
                type: PreferenceNamespace,
                key: PREFERENCES.rowHeight,
                val: size
            };

            this.setUserPreference(params).then((result) => {
                let {value} = result.data;
                this.userPrefs.row_height = value;
            })
        },

        /**
         * get a user preference
         *
         * @param Object opts = {type, key}
         * @return Promise
         */
        getUserPreference(opts = {}) {
            let {type, key} = opts;

            return axios.get(`/users/preference/${type}/${key}`);
        },

        /**
         * Set a user preference
         *
         * @param Object opts = {type, key, val}
         * @return Promise
         */
        setUserPreference(opts = {}) {
            let {type, key, val} = opts;

            return axios.post(`/users/preference/${type}/${key}`, {
                value: val
            });
        },

        fullscreenMode() {
            this.isFullscreen = true;
        },

        refreshTable(type) {
            if (type == 'aggregates') {
                this.refreshAggregatesOnly = true;
            }

            this.$refs.table.refresh();
        },
    },

    computed: {

        ...mapGetters('AcclaroSearchStore', [
            'query',
            'requestType',
            'datatableParams',
            'hiddenColumns',
            'getColumns',
        ]),


        columns: {
            get() {
                return this.getColumns;
            },

            set(value) {
                this.updateColumns(value);
            }
        },

        searchString: {
            get() {
                return this.query
            },

            set(value) {
                this.updateQueryValue(value)
            }
        },

        rowHeightClass() {
            return `rows-height-${this.userPrefs.row_height}`;
        },

        accountId() {
            return this.$store.state.TRMOnBehalfStore.onBehalfAccount.id;
        },

        defaultUserPrefs() {
            return this.userPrefs ? this.userPrefs : {row_height: 'default'};
        },

        resultCountStr() {
            let currentPage = this.currentPage;
            let resultsPerPage = this.tableOptions.perPage;
            let resultsCount = this.resultsCount;

            let rowEndCount = Math.min(currentPage * resultsPerPage, resultsCount);
            let rowStartCount = currentPage == 1 ? 1 : (resultsPerPage * (currentPage - 1));

            let str = `${rowStartCount}-${rowEndCount} of ${(this.numberWithCommas(resultsCount))}`;

            if (resultsCount < resultsPerPage) str = resultsCount;

            return str;
        },

        results() {
            const isAll = this.selectedResultType == 'All';

            let rows = this.searchResults.filter(result => isAll || result.type == this.selectedResultType);

            let headers = [];

            if (rows.length) {
                headers = Object.keys(rows[0]).map(name => name);
            }

            return {rows, headers};
        },

        hasFilters() {
            return Object.keys(this.filters).length > 0;
        },

        /**
         * Check if aggregate route has been set
         *
         */
        hasAggregateRoute() {
            return !isEmpty(this.aggregateRoute);
        },

        /**
         * Check if a filter route has been set
         *
         */
        hasFilterRoute() {
            return !isEmpty(this.filterRoute);
        },

        downloadHref() {
            //if a download route has been set on the component
            if (this.downloadRoute) {
                let params = Object.assign({}, this.datatableParams);

                return axios.getUri({
                    method: 'get',
                    url: this.downloadRoute,
                    params
                });
            }

            return this.downloadUrl;
        }
    },

    //@TODO - apply globally
    components: {
        AsCell,
        DownloadIcon,
        LoadingIcon,
        ResizeIcon,
        FilterOutlineIcon,
        CloseIcon,
        DensityOption,
        HideNShow
    },
};
</script>
